import { createContext, useContext } from "react";

import type { RightPaneState } from "../../app/state/right-pane/RightPaneState";

const RightPaneBoundaryContext = createContext<undefined | RightPaneState>(undefined);

export const RightPaneBoundaryContextProvider = RightPaneBoundaryContext.Provider;

export const useRightPaneBoundary = (): undefined | RightPaneState => useContext(RightPaneBoundaryContext);
